import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { CategoryService } from '@app/services/Category/category.service';
import { SubCategoryService } from '@app/services/SubCategory/sub-category.service';
import { Country, State, City } from 'country-state-city';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessAdsService } from '@app/services/BusinessAds/businessAds.service';
import { SearchListComponent } from '../search-list/search-list.component';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-search-filters',
  templateUrl: './searchFilters.component.html',
  styleUrls: ['./searchFilters.component.scss']
})
export class SearchFiltersComponent implements OnInit {
  public form!: FormGroup;
  categories: any;
  subCategories: any;
  countries: any;
  states: any;
  cities: any;
  serverImgUrl:any;

  router: string = '';
  selectedCountry:any;
  activrPage:any = false;

  @Input() searchList!: SearchListComponent;

  //For toggle hide show
	toggleClass: boolean = true;
  filterTabEvent(){
      this.toggleClass = !this.toggleClass;       
  }
 
  name = new FormControl(null, [Validators.required]);
  category = new FormControl(null);
  subCategory = new FormControl({ value: null, disabled: true });
  country = new FormControl(null);
  state = new FormControl({ value: null, disabled: true });
  city = new FormControl({ value: null, disabled: true });
  
  constructor(
    private categoryService: CategoryService,
    private subCatService: SubCategoryService,
    private adsService: BusinessAdsService,
  ) { 
    this.form = new FormGroup({
      name:this.name,
      category: this.category,
      subCategory: this.subCategory,
      country: this.country,
      state: this.state,
      city: this.city,
    });
  }
   
  ngOnInit() {
    this.serverImgUrl = environment.IMG_URL;
    this.getBusinessAds();
    this.categoryList();    
    this.getCountry();  
  }

  filterCriteria = {
    name: null,
    category: null,
    subCategory: null,
    country: null,
    state: null,
    district: null
  };

  reset():void {
    this.form.reset()
    this.searchList.applyFilter(this.filterCriteria);
  }
  
  applyFilter() {
    //console.log(this.filterCriteria);
    this.searchList.applyFilter(this.filterCriteria)
  }
  
  async getCountry() {
    this.countries = await Country.getAllCountries().map(country => ({
      value: country.isoCode,
      displayValue: `${country.name} - ${country.isoCode}`
    })) 
    this.getState();
  }

  async getState() {
    await this.country.valueChanges.subscribe(async (country) => {
      this.selectedCountry =country;
      this.state.reset();
      this.state.disable();
      if (country) {
        this.states = await State.getStatesOfCountry(country).map(state => ({
          value: state.isoCode,
          displayValue: `${state.name} - ${state.isoCode}`
        }))
        this.state.enable();
      }
    });
    
    this.getCity();
  }

  async getCity() {
    await this.state.valueChanges.subscribe(async (state) => {
      this.city.reset();
      this.city.disable();
      if (state) {
        this.cities = await City.getCitiesOfState(this.selectedCountry, state).map(city => ({
          value: city.name,
          displayValue: city.name
        }))
        this.city.enable();
      }
    });
  }

  async categoryList() {
    await this.categoryService.getAll().subscribe({
      next: (response: any) => {
        this.categories = response.data.map((item: any) => {
          return { name: item.CategoryName, id: item.CategoryInfoId };
        });
      }
    });
  }
  
  async selectSubCategory(e:any){
    this.category = e.target.value;
    await this.getSubCategoryList(this.category);
  }

  async getSubCategoryList(category:any) {
      this.subCategory.reset();
      this.subCategory.disable();
      if (category) {
        await this.subCatService.getSubcategoryById(category).subscribe({
       next: (response: any) => {
        this.subCategories = response.data.map((item: any) => {
          return { name: item.SubCategoryName, id: item.SubCategoryInfoId }
        });
      }
      })
      this.subCategory.enable();
      }
  };

  businessAds:any;
  // Get all business
  getBusinessAds(): void {
    this.adsService.getTop8BusinessAds().subscribe({
      next: (response:any) => {
        this.businessAds = response.data;
        }
      }
    );
  }
}
